import { useTranslation } from '@msdk/common'
import { ButtonPrimary, IconSelector } from '@msdk/ui'
import React from 'react'

import { ActionVisualizationMode } from './action-visualization'
import { ActionMenuItem, ActionMenuText } from './ActionMenuItem'

interface Props {
  entityName: string
  visualizationMode: ActionVisualizationMode
}

export function LogAction(props: Props) {
  const logEnabled = false
  const t = useTranslation()

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleLogClick = () => {}

  return (
    <>
      {logEnabled && props.visualizationMode === 'Buttons' && (
        <>
          <ButtonPrimary onClick={handleLogClick}>{t('CMPSR_LOG', 'Log')}</ButtonPrimary>
        </>
      )}
      {logEnabled && props.visualizationMode === 'MenuItems' && (
        <ActionMenuItem onClick={handleLogClick}>
          <IconSelector iconName="HistoryToggleOff" />
          <ActionMenuText>{t('CMPSR_LOG', 'Log')}</ActionMenuText>
        </ActionMenuItem>
      )}
    </>
  )
}
